export const TextEffectsStripedViewerType = 'wixui.TextEffectsStriped' as const;
export const TestIds = {
  viewer: {
    container: 'TextEffectsStriped-container',
    text: 'TextEffectsStriped-text',
  },
} as const;
